// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetChatEnabledByOfferRequest,
  TGetChatEnabledByOfferModel,
  IMappers,
  TGetChatEnabledByOfferResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IEnableResponseSchema } from '../../entities/user/EnableResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetChatEnabledByOfferModel(
  parameters: IGetChatEnabledByOfferRequest,
): TGetChatEnabledByOfferModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/get-chat-enabled-by-offer/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetChatEnabledByOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetChatEnabledByOfferRequest;
}

export async function fetchGetChatEnabledByOffer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetChatEnabledByOfferOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetChatEnabledByOfferResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetChatEnabledByOfferModel(parameters),
    config,
  )) as FetchResponse<TGetChatEnabledByOfferResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IEnableResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetChatEnabledByOfferResponse>;
}
